import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'router';
import { useOnboardingRoute } from 'hooks/useOnboardingRoute';
import { AccountCreatedV2 as AccountCreatedPage } from '@karehero/llama/pwa/pages/AccountCreatedV2/AccountCreatedV2';
import { clearIsNewKindeAccount } from 'store/slices/iamSlice';
import { dispatch } from 'store';
import { AccountRole, useTenant } from 'context';

export const AccountCreated = () => {
  const { tenant } = useTenant();
  const navigate = useNavigate();
  const { value: onboardingRoute, isReady } = useOnboardingRoute();
  const handleContinue = useCallback(() => {
    dispatch(clearIsNewKindeAccount());

    if (tenant.accountRole === AccountRole.ORG_OWNER) {
      navigate(ROUTES.PORTAL);
    } else if (tenant.session.isOnboarded) {
      navigate(ROUTES.ACTION_PLAN);
    } else if (
      tenant?.session?.isVerified &&
      !tenant.session.isReferringPartner
    ) {
      // The flags pick the onboarding; until they load, the gate waits for them.
      navigate(isReady ? onboardingRoute : ROUTES.HOME);
    } else if (tenant.session.isReferringPartner) {
      navigate(ROUTES.PARTNER_REGISTER);
    } else {
      navigate(ROUTES.VERIFY_ACCESS);
    }
  }, [isReady, navigate, onboardingRoute, tenant]);

  return <AccountCreatedPage onContinue={handleContinue} />;
};

AccountCreated.displayName = 'AccountCreated';
export default AccountCreated;
